// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__3Dr-6","Contact__Text":"Contact_Contact__Text__30IkJ"};